/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ITriageItemV2 } from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';
import { triageItemV2Schema } from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';

export const navigateCollectionTriageClipV2ResponseSchema = createApiResponseSchema(
  triageItemV2Schema,
) as z.ZodSchema<IAPI<ITriageItemV2 | null>>;

export type INavigateCollectionTriageClipV2Response = IAPI<ITriageItemV2 | null>;
